const materials = [
  "Steel",
  "Aluminum",
  "Stainless Steel",
  "Carbon Steel",
  "Anodized Aluminum",
  "Wood",
  "Acrylic",
  "Leather",
];

export default function MaterialsMarquee() {
  // Repeat list to create seamless scrolling
  const loop = [...materials, ...materials];

  return (
    <section
      id="materials"
      className="border-b border-zinc-800 bg-zinc-950 py-20 sm:py-28"
      data-testid="materials-section"
    >
      <div className="mx-auto max-w-7xl px-6">
        <p className="font-mono-spec mb-3 text-orange-500">// 02 — Materials We Run</p>
        <h2 className="font-display text-5xl text-white sm:text-6xl lg:text-7xl">
          If you can spec it,
          <br />
          <span className="text-zinc-500">we can cut it.</span>
        </h2>
      </div>

      {/* Marquee */}
      <div className="mt-14 overflow-hidden border-y border-zinc-800 bg-zinc-950 py-8">
        <div className="marquee-track" data-testid="materials-marquee-track">
          {loop.map((mat, idx) => (
            <div
              key={`${mat}-${idx}`}
              className="flex flex-shrink-0 items-center gap-10 px-10"
            >
              <span className="font-display text-5xl text-white sm:text-6xl lg:text-7xl">
                {mat}
              </span>
              <span className="h-3 w-3 flex-shrink-0 bg-orange-500" />
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-7xl px-6">
        <p className="max-w-2xl text-zinc-400">
          Working with something exotic? Send us the spec sheet — we&apos;ve cut
          everything from copper to brushed brass to high-density foams.
        </p>
      </div>
    </section>
  );
}
